//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'LayoutDefault',
  data() {
    return {
      leftDrawerOpen: false
    }
  },
  mounted() {

    // console.log('App.vye ' + this.$store.getters.uid)
    // console.log('App.vye ' + this.$store.getters.team)
    // console.log('App.vye BU=' + this.$store.getters.bu)

  },
  methods: {
    exit() {
      this.$q
        .dialog({
          title: "Confirm",
          message: "Do you want to exit application?",
          cancel: true,
          persistent: true
        })
        .onOk(() => {
          // console.log('>>>> OK')
          this.$router.replace({
            name: "signin"
          });
        })
        .onOk(() => {
          // console.log('>>>> second OK catcher')
        })
        .onCancel(() => {
          // console.log('>>>> Cancel')
        })
        .onDismiss(() => {
          // console.log('I am triggered on both OK and Cancel')
        })
    }

  }
}
